import { getPathName } from 'features/plc/contracts/pressHMI.schema';
import {
  getTestStandModeConfig,
  SETUP_TYPE,
  SUB_MODE,
  TS_PATHS,
} from 'features/plc/contracts/testStand.schema';

const getParamKeys = (setup, subMode) => getTestStandModeConfig(setup, subMode).paramKeys;

const BASE_SNAPSHOT_HANDLES = [
  TS_PATHS.run.testName,
  TS_PATHS.run.setupType,
  TS_PATHS.run.subMode,
];

export function getSnapshotHandles(setup, subMode) {
  const paramKeys = getParamKeys(setup, subMode);

  return [
    ...BASE_SNAPSHOT_HANDLES,
    ...paramKeys.map((key) => TS_PATHS.lipid.cmd.params[key]),
    ...paramKeys.map((key) => TS_PATHS.aqueous.cmd.params[key]),
  ];
}

function getPLCValue(values, path) {
  return values[getPathName(path)];
}

function buildChannelSnapshot(values, paths, paramKeys) {
  return paramKeys.reduce((params, key) => ({
    ...params,
    [key]: getPLCValue(values, paths.cmd.params[key]) ?? null,
  }), {});
}

/**
 * Builds a plain-object snapshot of current PLC state suitable for saving
 * to Firestore. Pass the result of `usePLCValues(getSnapshotHandles(setup, subMode))`.
 */
export function buildPLCSnapshot(values) {
  const setup = getPLCValue(values, TS_PATHS.run.setupType) || SETUP_TYPE.CONTINUOUS_FLOW;
  const subMode = getPLCValue(values, TS_PATHS.run.subMode) || SUB_MODE.DISPLACEMENT;
  const paramKeys = getParamKeys(setup, subMode);

  return {
    setup,
    ...(setup === SETUP_TYPE.DISCRETE_FLOW ? {
      subMode: subMode === SUB_MODE.PRESSURE ? 'pressure' : 'displacement',
    } : {}),
    testName: getPLCValue(values, TS_PATHS.run.testName) || '',
    channels: {
      lipid: { params: buildChannelSnapshot(values, TS_PATHS.lipid, paramKeys) },
      aqueous: { params: buildChannelSnapshot(values, TS_PATHS.aqueous, paramKeys) },
    },
  };
}
